function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.704 10.014c.92-.014 1.836-.006 2.75-.014.055 1.02.443 2.06 1.23 2.782.787.74 1.9 1.078 2.983 1.192v2.685c-1.015-.032-2.034-.232-2.955-.646a8.677 8.677 0 01-1.14-.62c-.004 1.948.009 3.894-.013 5.834a4.904 4.904 0 01-.951 2.628c-.92 1.278-2.517 2.112-4.157 2.138a5.341 5.341 0 01-2.869-.685c-1.42-.794-2.42-2.247-2.566-3.807a10.577 10.577 0 01-.008-.992c.127-1.269.789-2.483 1.816-3.308 1.165-.962 2.797-1.42 4.325-1.149.014.988-.028 1.974-.028 2.962-.698-.214-1.513-.154-2.123.248a2.332 2.332 0 00-.96 1.166c-.145.338-.104.714-.095 1.073.167 1.094 1.277 2.013 2.462 1.914a2.399 2.399 0 001.948-1.073c.132-.221.28-.448.288-.708.07-1.193.042-2.38.05-3.573.006-2.688-.008-5.368.014-8.047h-.001z",
  fill: "url(#tik-tok_svg__paint0_linear_1_920)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tik-tok_svg__paint0_linear_1_920",
  x1: 11.5,
  y1: 10.5,
  x2: 18.333,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#67869F"
})));

var SvgTikTok = function SvgTikTok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgTikTok;